import React from 'react';

import './ClothesOverview.scss';
import images from '../../shared/assets/images';
import BlockLink from '../BlockLink/BlockLink.jsx';

const { offers, fashionTrends, clothesPosition } = images;

export default function ClothesOverview(props) {
  return (
    <section id="clothesOverview">
      <ul id="clothesOverview_list">
        <li>
          <BlockLink
            link="/positiekleding"
            title="Positie kleding"
            imageUrl={clothesPosition}
            nextLink={props.nextLink}
          />
        </li>
        <li>
          <BlockLink
            link="/zwangerschapskleding-modetrends"
            title="Mode trends"
            imageUrl={fashionTrends}
            nextLink={props.nextLink}
          />
        </li>
        <li>
          <BlockLink
            link="/aanbiedingen"
            imageUrl={offers}
            title="Aanbiedingen"
            nextLink={props.nextLink}
          />
        </li>
      </ul>
    </section>
  );
}
